import Logo from "../components/Logo";

export default {
  default: {
    components: {
      Logo,
    },
  },
};
